//#rbp Initiate Action Types
//Authentication
export const LOGIN_LOADING = "LOGIN_LOADING";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_ERROR = "LOGIN_ERROR";
export const GET_PROFILE = "GET_PROFILE";
export const AUTH_USER_DETAILS_LOADING = "AUTH_USER_DETAILS_LOADING";
export const AUTH_USER_DETAILS_SUCCESS = "AUTH_USER_DETAILS_SUCCESS";
export const LOGGED_USER_DETAILS_LOADING = "LOGGED_USER_DETAILS_LOADING";
export const LOGGED_USER_DETAILS_SUCCESS = "LOGGED_USER_DETAILS_SUCCESS";
export const LOGGED_USER_DETAILS_ERROR = "LOGGED_USER_DETAILS_ERROR";
export const AGENCY_DETAILS_SUCCESS = "AGENCY_DETAILS_SUCCESS";
export const AGENCY_DETAILS_LOADING = "AGENCY_DETAILS_LOADING";
export const AGENCY_DETAILS_ERROR = "AGENCY_DETAILS_ERROR";
export const AGENCY_DELETE = "AGENCY_DELETE";
//Form
export const ADD_NEW_FIELD = "ADD_NEW_FIELD";
export const ADD_OPTION = "ADD_OPTION";
export const GET_DATA = "GET_DATA";
export const DELETE = "DELETE";
export const SINGLE_DATA = "SINGLE_DATA";
export const VALUE_CHANGES = "VALUE_CHANGES";
export const DRAG_DROP = "DRAG_DROP";
export const DUPLICATE = "DUPLICATE";
export const OPTION_VALUES = "OPTION_VALUES";
export const OPTION_DELETE = "OPTION_DELETE";
export const RESET_STATE = "RESET_STATE";
export const ADD_DUPLICATE = "ADD_DUPLICATE";
//logout
export const LOG_OUT = "LOG_OUT";
//document
export const ADD_DOCUMENT = "ADD_DOCUMENT";
export const DELETE_DOCUMENT = "DELETE_DOCUMENT";
export const DOCUMENT_VALUE = "DOCUMENT_VALUE";
export const FORM_DETAILS = "FORM_DETAILS";
export const NEW_FROM = "NEW_FROM";
export const DOCUMENT_DETAILS = "DOCUMENT_DETAILS";
export const NEW_DOCUMENT = "NEW_DOCUMENT";
//
export const CATEGORY_DETAILS = "CATEGORY_DETAILS";
export const NEWFORM = "NEWFORM";
export const ADD_CATEGORY = "ADD_CATEGORY";
export const CATEGORY_ONCHANGE = "CATEGORY_ONCHANGE";

//End user form
export const END_USER_DETAILS_LOADING = "END_USER_DETAILS_LOADING";
export const END_USER_DETAILS_SUCCESS = "END_USER_DETAILS_SUCCESS";
export const END_USER_DETAILS_ERROR = "END_USER_DETAILS_ERROR";
export const CUSTOMER_CATEGORY_NAVIGATION = "CUSTOMER_CATEGORY_NAVIGATION";
//dog
export const DOG_LIST = "DOG_LIST";
export const ALL_DOG = "ALL_DOG";
//Choose plan
export const CHOOSE_PLAN_LOADING = "CHOOSE_PLAN_LOADING";
export const CHOOSE_PLAN_SUCCESS = "CHOOSE_PLAN_SUCCESS";
export const CHOOSE_PLAN_ERROR = "CHOOSE_PLAN_ERROR";

export const DOG_PLAN_DETAILS_SUCCESS = "DOG_PLAN_DETAILS_SUCCESS";
export const DOG_PLAN_DETAILS_RESET = "DOG_PLAN_DETAILS_RESET";

export const GOTO_NEXT_STEP = "GOTO_NEXT_STEP";
export const FIELD_VALIDATE_USER = "FIELD_VALIDATE_USER";
export const GOTO_PREVIOUS_STEP = "GOTO_PREVIOUS_STEP";
export const GOTO_SELECTED_STEP = "GOTO_SELECTED_STEP";

export const SAVE_BASE64_WEBFORM = "SAVE_BASE64_WEBFORM";
